'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var TruncateText = require('../../../../utils/TruncateText.js');
var Typography = require('../../Typography/Typography.js');
var ClipboardWrapper = require('../../../../utils/ClipboardWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TextTableCellContent = function TextTableCellContent(_ref) {
  var _ref$wrapperComponent = _ref.wrapperComponent,
      Wrapper = _ref$wrapperComponent === void 0 ? 'div' : _ref$wrapperComponent,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      truncate = _ref.truncate,
      maxLines = _ref.maxLines,
      dependencies = _ref.dependencies,
      children = _ref.children,
      wordBreak = _ref.wordBreak,
      copyable = _ref.copyable,
      props = objectWithoutProperties(_ref, ["wrapperComponent", "wrapperProps", "truncate", "maxLines", "dependencies", "children", "wordBreak", "copyable"]);

  return React__default["default"].createElement(Wrapper, wrapperProps, copyable ? React__default["default"].createElement(ClipboardWrapper, {
    textToCopy: children
  }, React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), React__default["default"].createElement(TruncateText, {
    truncate: truncate,
    maxLines: maxLines,
    dependencies: dependencies,
    wordBreak: wordBreak
  }, children))) : React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), React__default["default"].createElement(TruncateText, {
    truncate: truncate,
    maxLines: maxLines,
    dependencies: dependencies,
    wordBreak: wordBreak
  }, children)));
};

module.exports = TextTableCellContent;
